import React from "react";
import { Box, Modal, Card } from "@mui/material";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./BuyToken.module.css";
import { useEffect } from "react";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import Radio from "@mui/material/Radio";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const BuyToken = ({ open, handleClose, tokenSelectionResponse, availableTokens }) => {
	// console.log('availableTokens: ', availableTokens);
	const classes = useStyles();
	const [selectedToken, setSelectedToken] = useState("");
	const [enableBtn, setEnableBtn] = useState(false);
	const [allTokens, setAllTokens] = useState([]);
	useEffect(() => {
		const tokens = availableTokens.map((tk) => {
			tk.isSelected = false;
			return tk;
		});
		console.log({ tokens });
		setAllTokens(tokens);
	}, [availableTokens]);
	function closeModal() {
		handleClose();
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Token Payment</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.tokenTable}>
						<div className={cssClasses.blockLabel}>
							Select Token <span style={{ color: "red" }}> *</span>
						</div>
						<div className={cssClasses.wrapperTable}>
							{allTokens.map((eachToken, index) => (
								<Card className={cssClasses.tokenCard} key={index}>
									<div style={{ width: "4rem" }}>
										{eachToken?.startPaymentFrom < new Date() && (
											<Radio
												checked={eachToken?.isSelected}
												onChange={(e) => {
													console.log("e: ", e);
													setAllTokens((pre) => {
														pre = pre.map((m) => ({
															...m,
															isSelected: false,
														}));
														console.log(pre);
														pre[index].isSelected = true;
														return [...pre];
													});
													setSelectedToken(eachToken);
													setEnableBtn(true);
												}}
											/>
										)}
									</div>
									<div className={cssClasses.labelValue}>
										<div style={{ width: "calc(50% - 2rem)" }}>
											<span className={classes.tokenName}>{eachToken.tokenId?.name}</span>
										</div>
										<div style={{ width: "calc(25% - 2rem)" }}>
											<span className={classes.labelValue}>{eachToken.tokenId?.inventoryTypeId?.type}</span>
										</div>
										<div style={{ width: "calc(25% - 2rem)" }}>
											<span className={classes.labelValue}>₹{numberWithCommas(eachToken.tokenId?.amount)}</span>
										</div>
										<div style={{ marginTop: "1rem" }}>
											{eachToken?.startPaymentFrom > new Date() && (
												<span className={cssClasses.chip}>
													<AccessTimeIcon style={{ color: "red" }} />
													Will be available from {new Date(eachToken.startPaymentFrom).toDateString()},
													{new Date(eachToken.startPaymentFrom).toLocaleTimeString([], {
														hour: "2-digit",
														minute: "2-digit",
													})}{" "}
													onwards
												</span>
											)}
										</div>
									</div>
								</Card>
							))}
							{/* {allTokens.map((eachToken, index) => {
                                return (
                                    <Card className={cssClasses.tokenCard} key={index}>
                                        <div>
                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            color: "#155EEF !important",
                                                            fontSize: "2rem !important",
                                                        },
                                                    }}
                                                    value={eachToken.isSelected}
                                                    onChange={(e) => {
                                                        setAllTokens((pre) => {
                                                            pre = pre.map((m) => ({
                                                                ...m,
                                                                isSelected: false,
                                                            }));
                                                            console.log(pre);
                                                            pre[index].isSelected = true;
                                                            return [...pre];
                                                        });
                                                        setSelectedToken(eachToken);
                                                        setEnableBtn(true);
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        className={classes.radioLabel}
                                                        value={true}
                                                        control={<Radio />}
                                                        label={
                                                            <div className={classes.radioLabel}></div>
                                                        }
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                        <div className={cssClasses.labelValue}>
                                            <div>
                                                <span className={classes.tokenName}>
                                                    {eachToken.tokenId?.name}
                                                </span>
                                            </div>
                                            <div>
                                                <span className={classes.labelValue}>
                                                    {eachToken.tokenId?.inventoryTypeId?.type}
                                                </span>
                                            </div>
                                            <div>
                                                <span className={classes.labelValue}>
                                                    ₹{number(eachToken.tokenId?.amount)}
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                );
                            })} */}
						</div>
					</div>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#344054",
								backgroundColor: "#ffffff",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Cancel"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
					<div>
						<Button
							style={{
								color: "#ffffff",
								backgroundColor: "#155EEF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							disable={!enableBtn}
							btnName={"Buy Now"}
							clicked={() => {
								tokenSelectionResponse(selectedToken);
								handleClose();
							}}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default BuyToken;
